import moment from 'moment'
import timezones from 'compact-timezone-list'
import { KUDO_SELECT_TYPE, KUDO_TYPE, PRONOUN_TYPE } from './types'
import { ALL_MEMBERS_ID } from '@/helpers/constants'

export const CurrentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

export const PronounOptions = [
  { value: PRONOUN_TYPE.HE_HIS, text: 'He/His' },
  { value: PRONOUN_TYPE.SHE_HER, text: 'She/Her' },
  { value: PRONOUN_TYPE.THEY_THEM, text: 'They/Them' }
]

export function filterNullFields(toBeFiltered) {
  const filtered = {}
  Object.keys(toBeFiltered).forEach((key) => {
    const value = toBeFiltered[key]
    if (value !== null && value !== undefined) {
      filtered[key] = toBeFiltered[key]
    }
  })
  return filtered
}

export function toFormData(data, includeNull = false) {
  const formData = new FormData()

  const inData = includeNull ? data : filterNullFields(data)

  Object.keys(inData).forEach(key => {
    formData.append(key, data[key])
  })

  return formData
}

export function utoa(text) {
  return btoa(unescape(encodeURIComponent(text)))
}

export function atou(text) {
  return decodeURIComponent(escape(atob(text)))
}

export function toastError(vue, content, title) {
  vue.$bvToast.toast(content || 'Unexpected error', {
    title: title || 'Error',
    variant: 'danger',
    solid: true
  })
}

export function teamsQuery(teams, profiles, query = '') {
  if (!query || query.length < 2) return teams

  const result = []
  const qlc = query.toLowerCase()
  teams.forEach(team => {
    const members = []
    team.members.forEach(member => {
      const profile = profiles[member.profile]
      const name = userName(profile).toLowerCase()
      if (name.indexOf(qlc) !== -1) {
        members.push(member)
      }
    })

    if (members.length > 0 ||
      (team.id !== ALL_MEMBERS_ID ? team.name.toLowerCase().indexOf(qlc) !== -1 : false)) {
      result.push({ ...team, members: members })
    }
  })
  return result
}

export function kudosQuery(kudos, received = [], query = '', type = KUDO_SELECT_TYPE.ALL) {
  const qlc = query.toLowerCase()

  const result = []
  kudos.forEach(kudo => {
    let valid = true

    switch (type) {
      case KUDO_SELECT_TYPE.RECEIVED:
        valid = Boolean(received.find(p => p.kudo === kudo.id))
        break
      case KUDO_SELECT_TYPE.BEHAVIORS:
        valid = kudo.type === KUDO_TYPE.BEHAVIORS
        break
      case KUDO_SELECT_TYPE.EXPERTISE:
        valid = kudo.type === KUDO_TYPE.EXPERTISE
        break
    }

    if (valid && qlc && kudo.name.toLowerCase().indexOf(qlc) === -1) {
      valid = false
    }

    if (valid) {
      result.push(kudo)
    }
  })
  return result
}

export function messagesQuery(messages, query = '', dateDir = 'asc') {
  let result = messages
  if (query && query.length > 1) {
    const qlc = query.toLowerCase()
    result = messages.filter(message => {
      let valid = false
      if (message.sender) {
        if (message.sender.type === 'user') {
          valid = valid || userName(message.sender).toLowerCase().indexOf(qlc) !== -1
        }
      }

      if (message.receivers) {
        message.receivers.forEach(receiver => {
          if (receiver.type === 'user') {
            valid = valid || userName(receiver).toLowerCase().indexOf(qlc) !== -1
          }
        })
      }

      valid = valid || message.content.toLowerCase().indexOf(qlc) !== -1
      valid = valid || message.category.toLowerCase().indexOf(qlc) !== -1
      return valid
    })
  }

  const isAsc = dateDir === 'asc'
  return result.sort((m1, m2) => {
    const d1 = moment(m1.createdAt)
    const d2 = moment(m2.createdAt)
    if (d1 === d2) {
      return 0
    }
    return d1 > d2 ? (isAsc ? 1 : -1) : (isAsc ? -1 : 1)
  })
}

export function profileQuery(profiles, query = '') {
  const result = {}
  const qlc = query.toLowerCase()
  for (const profileId in profiles) {
    const profile = profiles[profileId]
    if (userName(profile).toLowerCase().indexOf(qlc) !== -1) {
      result[profile.id] = profile
    }
  }
  return result
}

export function userName(profile) {
  return `${profile.firstName} ${profile.lastName}`
}

export function readFile(file, callback) {
  if (file) {
    const reader = new FileReader()
    reader.onload = callback
    reader.readAsDataURL(file)
  }
}

export function stripeHTML(text) {
  return text.replace(/<\/?[^>]+(>|$)/g, '')
}

export function linebreaks(text) {
  const txt = text.replace(/\r\n/gi, '\n').replace(/\n\r/gi, '\n').replace(/\r/gi, '\n')
  const parts = txt.split(/\n{2,}/gi)
  return parts.map(p => `<p>${stripeHTML(p).replace(/\n/gi, '<br>')}</p>`).join('')
}

export function getTimezone(tzCode) {
  return timezones.find(tz => tz.tzCode === tzCode)
}
